<script lang="typescript">
    import { renderProductCode } from "./utils";
    import type { LensCode, LensSubCategory } from "./types";
    export let code: LensCode | LensSubCategory[];
    export let classes: string = "";
</script>

<dl class="{classes} bg-white p-4 rounded-md">
    {#if Array.isArray(code)}
        {#each code as subCategory}
            <div class="grid grid-cols-3 border-b border-gray-200 pb-2">
                <dd class="font-medium min-w-min">{subCategory.name}</dd>
                <dt class="col-span-2">{@html renderProductCode(subCategory.code)}</dt>
            </div>
        {/each}
    {:else}
        <div class="grid grid-cols-3">
            <dd class="font-medium">Product code</dd>
            <dt class="col-span-2">{@html renderProductCode(code)}</dt>
        </div>
    {/if}
</dl>

<style>
    dl > div:last-of-type {
        @apply border-0 pb-0;
    }
</style>
